// IndiaPhD.js
import React from "react";
import Header from "../../components/Header";

import Footer from "../../components/Footer";
import "../../styles/PhDCountry.css";
import DrpEduNavbar from "../../components/DrpEduNavbar";
const IndiaPhD = () => {
  return (
    <>
      <Header />
      <DrpEduNavbar />

      <div className="phd-container">
        <h1 className="country-title">🎓 PhD & Postdoc in India</h1>

        {/* PhD Section */}
        <section className="phd-section">
          <h2>PhD – Basic Information</h2>
          <ul>
            <li>
              <strong>Degree:</strong> Doctor of Philosophy (PhD)
            </li>
            <li>
              <strong>Duration:</strong> 3 to 6 years
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>
                  Master’s degree (or equivalent) in a relevant field with at
                  least 55% marks (50% for SC/ST/OBC)
                </li>
                <li>
                  Entrance exam required (varies by institution):
                  <ul>
                    <li>UGC-NET / CSIR-NET / GATE / JRF</li>
                    <li>Or university-specific PhD entrance tests</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Selection:</strong> Entrance exam + Interview
            </li>
            <li>
              <strong>Fellowship:</strong>
              <ul>
                <li>
                  JRF: ₹31,000–₹35,000/month (first 2 years), SRF:
                  ₹35,000–₹38,000/month
                </li>
                <li>Funded by UGC, CSIR, DST, DBT, or institutions</li>
              </ul>
            </li>
          </ul>
        </section>

        {/* Postdoc Section */}
        <section className="postdoc-section">
          <h2>Postdoc – Basic Information</h2>
          <ul>
            <li>
              <strong>Position:</strong> Research Associate (RA) / Postdoctoral
              Fellow (PDF)
            </li>
            <li>
              <strong>Duration:</strong> 1 to 3 years
            </li>
            <li>
              <strong>Eligibility:</strong>
              <ul>
                <li>PhD degree in a relevant field</li>
                <li>Good publication record (SCI/Scopus journals)</li>
              </ul>
            </li>
            <li>
              <strong>Fellowship/Stipend:</strong> ₹47,000–₹54,000/month (varies
              by funding agency)
            </li>
            <li>
              <strong>Funding Agencies:</strong> DST, DBT, CSIR, ICMR, SERB,
              UGC, IITs, IISc
            </li>
            <li>
              <strong>Opportunities:</strong> Usually under funded projects or
              fellowships (National Postdoctoral Fellowship - NPDF)
            </li>
          </ul>
        </section>

        {/* Top Universities Section */}
        <section className="universities-section">
          <h2>Top Universities & Institutes in India</h2>
          <ol>
            <li>
              <strong>Indian Institute of Science (IISc), Bangalore</strong>
              <p>
                India’s #1 research institute. Strong programs in science,
                engineering, and interdisciplinary fields.
              </p>
            </li>
            <li>
              <strong>
                Indian Institutes of Technology (IITs) – All major campuses
              </strong>
              <p>
                Notable: IIT Bombay, IIT Delhi, IIT Madras, IIT Kanpur, IIT
                Kharagpur. High-level PhD & postdoc programs with government
                funding.
              </p>
            </li>
            <li>
              <strong>Jawaharlal Nehru University (JNU), New Delhi</strong>
              <p>
                Renowned for humanities, social sciences, international
                relations, and life sciences.
              </p>
            </li>
            <li>
              <strong>University of Delhi (DU), New Delhi</strong>
              <p>Offers PhD in various disciplines with UGC-NET/JRF support.</p>
            </li>
            <li>
              <strong>
                Tata Institute of Fundamental Research (TIFR), Mumbai &
                Hyderabad
              </strong>
              <p>
                Elite institute for PhD/Postdoc in physics, biology,
                mathematics, and computer science.
              </p>
            </li>
            <li>
              <strong>
                Indian Statistical Institute (ISI), Kolkata & Bangalore
              </strong>
              <p>
                Premier institute for research in statistics, mathematics,
                computer science, and economics.
              </p>
            </li>
            <li>
              <strong>
                National Institutes of Technology (NITs) – Select campuses
              </strong>
              <p>Strong in engineering and applied sciences.</p>
            </li>
            <li>
              <strong>
                Indian Institute of Science Education and Research (IISERs)
              </strong>
              <p>Known for cutting-edge science research and PhD programs.</p>
            </li>
            <li>
              <strong>Banaras Hindu University (BHU), Varanasi</strong>
              <p>
                Large variety of research areas, especially in science and
                Indian heritage studies.
              </p>
            </li>
            <li>
              <strong>University of Hyderabad (UoH), Hyderabad</strong>
              <p>
                Recognized for social sciences, science, and interdisciplinary
                PhD programs.
              </p>
            </li>
          </ol>
        </section>

        <a href="/" className="back-home-button">
          Go Back Home
        </a>
      </div>

      <Footer />
    </>
  );
};

export default IndiaPhD;
